import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { CircularProgress, Switch as MuiSwitch } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import ComplexStatisticsCard from "components/Cards/StatisticsCards/ComplexStatisticsCard";
import { useEffect, useState } from "react";
import PageHeader from "components/pageHead/pageHead";
import { commonChips } from "constants/common/pageHeaderChips";
import Layout from "components/LayoutContainers/mainLayout";
import ReportYearFilter from "components/reportYearFilter/reportYearFilter";
import CardsDash from "components/cardsDashBoard/cardsDashBoard";
import BarChart from "./charts/barChart";
import ReportTable from "./charts/reportTable";
import { PichartReport } from "./charts/pieChart";
import { getMonthNumberFromDate } from "utils/common/getMonthNumber";
import { GeneralFetch } from "Api/generalFetch/generalFetch";
import { MonthsLabels } from "constants/common/formConstants";
import { locais } from "constants/common/formConstants";
import { coolors } from "constants/common/formConstants";
import { getUsers } from "hooks/users/getUsers";
import { toMakeReportsCtegories } from "constants/forms/danos";
import { Switch } from "antd";
import { getDateInstring } from "utils/common/getDateInString";
import { fixedPeriods } from "components/reportYearFilter/reportYearFilter";

function Relatorios() {
    const [selected, setSelected] = useState('todos')
    const [local, setLocal] = useState("todos")
    const [reporters, setReporters] = useState({ reporters: [] })
    const [goldenRulesChart, setGoldenRules] = useState({
        possiveisDanos: { byStatus: { labels: [], datasets: [] }, aggregate: { labels: [], datasets: [] } },
    })
    const [chartData, setChartData] = useState({
        reportado_por: { pie: { labels: [], datasets: [] }, bar: { labels: [], datasets: [] } },
        local: { pie: { labels: [], datasets: [] }, bar: { labels: [], datasets: [] } },
        classe: { pie: { labels: [], datasets: [] }, bar: { labels: [], datasets: [] } },
        stop_card: { pie: { labels: [], datasets: [] }, bar: { labels: [], datasets: [] } }
    })
    const [period, setPeriod] = useState(new Date().getFullYear())
    const [yearlyChart, setYearLyChartData] = useState({ labels: [], datasets: [] })
    const [cardsData, setCardsData] = useState({ loading: false, data: [] })
    const [chipsCardsData, setChipsCardsData] = useState({ loading: false, data: {} })
    const [monthly, setMonthly] = useState(false)
    const [customDate, setCustom] = useState(false)
    const [showTable, setShowTable] = useState(false)
    const { fetchData } = GeneralFetch()
    const [loading1, setLoading] = useState(false)
    const [loading2, setLoading2] = useState(false)
    const [loading3, setLoading3] = useState(false)
    const variableList = ['reportado_por', 'local', 'stop_card', 'classe']
    const variableList2 = ['possiveisDanos']
    const classeDataSet = [
        {
            label: 'Aberto',
            key: "1",
            backgroundColor: 'rgba(235, 208, 54, 0.7)',
        },
        {
            label: 'Fechado',
            key: "3",
            backgroundColor: 'rgba(54, 235, 99, 0.5)',
        },
        {
            label: 'N/A',
            key: "2",
            backgroundColor: 'rgba(39, 46, 41, 0.5)',
        },
    ];
    const updatedChips = [{ label: "Todos registos", value: "todos" }, ...commonChips]
    const { users } = getUsers()
    const boapratica = selected == 'boaspraticas' ? "true" : selected == "nearmisses" ? "false" : "N/A"
    const isLoading = loading1 || loading2 || loading3

    useEffect(() => {
        // Reset states when selected, period, or local change
        setGoldenRules({
            possiveisDanos: { byStatus: { labels: [], datasets: [] }, aggregate: { labels: [], datasets: [] } },
        })
        setChartData({
            reportado_por: { pie: { labels: [], datasets: [] }, bar: { labels: [], datasets: [] } },
            local: { pie: { labels: [], datasets: [] }, bar: { labels: [], datasets: [] } },
            classe: { pie: { labels: [], datasets: [] }, bar: { labels: [], datasets: [] } },
            stop_card: { pie: { labels: [], datasets: [] }, bar: { labels: [], datasets: [] } }
        })
        setYearLyChartData({ labels: [], datasets: [] })
        setCardsData({ loading: false, data: [] })
        setChipsCardsData({ loading: false, data: {} })
    }, [selected, period, local, reporters.reporters])

    useEffect(() => {
        setLoading(true)
        const fetchDataAsync = async () => await fetchData({}, `getYearReport?${reporters.reporters?.length > 0 ? `reportado_por=${reporters.reporters.join(',')}&` : ""}${local != 'todos' ? `local=${local}&` : ""}${period.toString()?.includes('startDate') ? period : 'period=' + getMonthNumberFromDate(period)}&object=${selected == 'boaspraticas' ? 'nearmisses' : selected}&boapratica=${boapratica}`, 'get', '')
        void fetchDataAsync().then((data) => {
            let chartDataSets = []

            MonthsLabels.forEach((_, index) => {
                const Arrayelement = Array.isArray(data) ? data.find(x => x.month === index + 1) : undefined;
                if (Arrayelement != undefined) chartDataSets.push(Arrayelement.data)
                else chartDataSets.push(0)
            });

            setYearLyChartData({
                labels: MonthsLabels,
                datasets: [
                    {
                        label: updatedChips.find(chip => chip.value === selected).label,
                        data: chartDataSets,
                        backgroundColor: 'rgba(68, 151, 206, 0.5)',
                    }
                ]
            })
            setLoading(false)
        })
    }, [selected, period, local, reporters.reporters])

    useEffect(() => {
        setLoading2(true)
        const filteredUsers = reporters.reporters?.length > 0 ? users?.filter(x => reporters.reporters?.includes(x.value)) : users

        const objData = {
            reportado_por: filteredUsers,
            local: locais,
            stop_card: [{ label: "Stop Card", value: '1' }, { label: "Sem Stop Card", value: '0' }],
            classe: [{ label: "Classe A", value: 'A' }, { label: "Classe B", value: 'B' }, { label: "Classe C", value: 'C' }]
        }

        if (filteredUsers?.length > 0) {
            for (let variable of variableList) {
                setLoading2(true)
                let classesDataSets = [...classeDataSet]

                const fetchDataAsync = async () => await fetchData({}, `sideBySideReports?${reporters.reporters?.length > 0 ? `reportado_por=${reporters.reporters.join(',')}&` : ""}${local != 'todos' ? `local=${local}&` : ""}${period.toString()?.includes('startDate') ? period : 'period=' + getMonthNumberFromDate(period)}&object=${selected == 'boaspraticas' ? 'nearmisses' : selected}&boapratica=${boapratica}&variable=${variable}`, 'get', '')
                void fetchDataAsync().then((data) => {
                    const keys = Object?.keys?.(data?.bar)
                    let labels = []
                    let labelsPie = []
                    let PieData = []

                    keys.forEach((element, keyIndex) => {
                        labels.push(objData?.[variable]?.find(x => x.value == element)?.label)
                        data?.bar?.[element]?.records?.forEach(elemen => {
                            const index = classesDataSets.findIndex(x => x.key == elemen.estado)

                            const existing = [...(classesDataSets[index]?.data || Array(data?.bar?.length).fill(0))]
                            existing[keyIndex] = elemen.data
                            classesDataSets[index] = { ...classesDataSets[index], data: existing }
                        })
                    });

                    data?.pie?.forEach(elemen => {
                        labelsPie.push(objData?.[variable]?.find(x => x.value == elemen[variable])?.label)
                        PieData.push(elemen.data)
                    })

                    setChartData(prev => ({
                        ...prev, [variable]: {
                            pie: {
                                labels: labelsPie,
                                datasets: [
                                    {
                                        label: 'Reportes',
                                        data: PieData,
                                        borderWidth: 1,
                                        backgroundColor: PieData.map((_, idx) => coolors[idx]),
                                        borderColor: [
                                            '#939694',
                                        ],
                                    }
                                ]
                            },
                            bar: {
                                labels: labels,
                                datasets: classesDataSets
                            }
                        }
                    }))


                    setLoading2(false)
                })
            }
        }
    }, [selected, period, users, local, reporters.reporters])

    useEffect(() => {
        setCardsData({ data: [], loading: true })
        const fetchDataAsync = async () => fetchData({}, `getCardsData?${reporters.reporters?.length > 0 ? `reportado_por=${reporters.reporters.join(',')}&` : ""}${local != 'todos' ? `local=${local}&` : ""}${period.toString()?.includes('startDate') ? period : 'period=' + getMonthNumberFromDate(period)}&object=${selected == 'boaspraticas' ? 'nearmisses' : selected}&boapratica=${boapratica}`, 'get', '')
        void fetchDataAsync().then((data) => {
            setCardsData({ data: data, loading: false })
        })
    }, [selected, period, local, reporters.reporters])

    useEffect(() => {
        setLoading3(true)
        const objData = {
            possiveisDanos: toMakeReportsCtegories,
        }

        for (const reports of variableList2) {
            setLoading3(true)
            const fetchDataAsync = async () => await fetchData({ rules: objData[reports] }, `goldenRulesReports?${reporters.reporters?.length > 0 ? `reportado_por=${reporters.reporters.join(',')}&` : ""}${local != 'todos' ? `local=${local}&` : ""}${period.toString()?.includes('startDate') ? period : 'period=' + getMonthNumberFromDate(period)}&object=${selected == 'boaspraticas' ? 'nearmisses' : selected}&boapratica=${boapratica}&reportVariable=${reports}`, 'post', '')
            void fetchDataAsync().then((data) => {
                const aggregate = data?.aggregate
                const byStatus = data?.byStatus
                let classesDataSets = [...classeDataSet]
                let dataSets = []

                for (const element of objData[reports]) {
                    if (aggregate?.[element.sectionId]) dataSets.push(aggregate?.[element.sectionId])
                    else dataSets.push(0)
                }

                if (byStatus) {
                    Object.keys(byStatus).forEach((key) => {
                        let dataSets2 = []
                        const index = classesDataSets.findIndex(x => x.key == key)
                        for (const element of objData[reports]) {
                            if (byStatus[key]?.[element.sectionId]) {
                                dataSets2.push(byStatus[key]?.[element.sectionId])
                            }
                            else dataSets2.push(0)
                        }
                        classesDataSets[index] = { ...classesDataSets[index], data: dataSets2 }
                    })
                }

                const labels = objData[reports]?.map(x => x?.description ?? '')

                setGoldenRules(prev => ({
                    ...prev, [reports]: {
                        aggregate: {
                            labels: dataSets.every(item => item === 0) ? [] : labels,
                            datasets: [
                                {
                                    label: 'Reportes',
                                    data: dataSets,
                                    backgroundColor: reports == 'possiveisDanos' ? dataSets.map((_, idx) => coolors[idx]) : 'rgba(75, 192, 192, 0.5)',
                                    borderColor: [
                                        '#939694',
                                    ],
                                }
                            ]
                        },
                        byStatus: {
                            labels: dataSets.every(item => item === '') ? [] : labels,
                            datasets: classesDataSets
                        }
                    }
                }))
                setLoading3(false)
            })
        }
    }, [selected, period, local, reporters.reporters])

    // Fetch individual chips cards data when selected is 'todos'
    useEffect(() => {
        if (selected === 'todos') {
            setChipsCardsData({ loading: true, data: {} })
            const fetchChipsData = async () => {
                const newData = {}
                for (const chip of commonChips) {
                    try {
                        const data = await fetchData({}, `getCardsData?${reporters.reporters?.length > 0 ? `reportado_por=${reporters.reporters.join(',')}&` : ""}ignoreGroup=true&${local != 'todos' ? `local=${local}&` : ""}${period.toString()?.includes('startDate') ? period : 'period=' + getMonthNumberFromDate(period)}&object=${chip.value}`, 'get', '')
                        newData[chip.value] = data
                    } catch (error) {
                        console.error(`Error fetching data for ${chip.value}:`, error)
                        newData[chip.value] = []
                    }
                }
                setChipsCardsData({ loading: false, data: newData })
            }
            fetchChipsData()
        } else {
            setChipsCardsData({ loading: false, data: {} })
        }
    }, [selected, period, local, reporters.reporters])

    // console.log(chartData?.reportado_por)
    return (
        <Layout>

            <PageHeader selected={selected} setSelected={setSelected} chips={updatedChips} showAddBtn={false} />

            <Grid container marginTop={"0px"} spacing={6}>
                <Grid item xs={12}>
                    <Card>
                        <MDBox
                            mx={2}
                            mt={-3}
                            py={0}
                            px={0} ariant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info" >
                            {/* {loadingPareto && <LinearProgressComponent />} */}

                            <div style={{ display: "flex", justifyContent: "space-between", height: "25px", margin: "10px 10px 20px 10px" }} >
                                <MDTypography variant="h6" color="white" style={{ marginTop: "5px" }}>
                                    Relatório {updatedChips.find(chip => chip.value === selected).label}
                                </MDTypography>
                                <div style={{ display: "flex", color: "#fff" }} >
                                    <div style={{ display: "flex" }} ><h6 style={{ marginTop: "10px" }} >Últimos 6 meses</h6><MuiSwitch disabled={isLoading} checked={monthly} onChange={(e) => { setMonthly(e.target.checked); setCustom(false) }} /></div>
                                    <div style={{ display: "flex" }} ><h6 style={{ marginTop: "10px" }} >Datas Personalizadas</h6><MuiSwitch disabled={isLoading} checked={customDate} onChange={(e) => { setMonthly(false); setCustom(e.target.checked) }} /></div>
                                    {/* {(user?.acesso != '1' && selected == 'nearmisses') && <IconButton onClick={() => { downloadPareto() }} style={{ borderRadius: "0", height: "40px" }} >
                                        <span style={{ fontSize: "15px", cursor: "pointer" }}><h6 style={{ marginTop: "10px", color: "#FFFAFF" }} ><DownloadIcon />Gerar PARETO</h6></span>
                                    </IconButton>} */}
                                </div>
                            </div>
                        </MDBox>
                        <MDBox pt={3}>
                            <ReportYearFilter
                                reporters={reporters}
                                setReporters={setReporters}
                                users={users}
                                disabled={isLoading}
                                local={local}
                                setLocal={setLocal}
                                selected={period}
                                setPeriod={setPeriod}
                                fullYear={false}
                                showSelect={true}
                                customDate={customDate}
                                monthly={monthly}
                            />
                        </MDBox>
                    </Card>
                    <CardsDash loading={cardsData?.loading} cardsData={cardsData?.data} />
                    {/* Individual chips cards when selected is 'todos' */}
                    {selected === 'todos' && (
                        <Grid container mt={0.5} mb={1} spacing={3}>
                            {commonChips.map((chip) => {
                                const data = chipsCardsData.data[chip.value] || []
                                const total = Array.isArray(data) ? data?.[0]?.total : 0
                                return (
                                    <Grid item xs={12} md={6} lg={4} key={chip.value}>
                                        <MDBox mb={1.5}>
                                            <ComplexStatisticsCard
                                                color={chip.color}
                                                icon={chipsCardsData.loading ? <CircularProgress style={{ color: "#fff" }} size={"24px"} /> : chip.icon}
                                                title={chip.label}
                                                count={total || 0}
                                            />
                                        </MDBox>
                                    </Grid>
                                )
                            })}
                        </Grid>
                    )}
                    <Card>
                        <MDBox mx={2} mt={-3} py={3} px={2}>
                            {!monthly && <BarChart data={yearlyChart} loading={loading1} label={`${period.toString()?.includes('startDate') ? getDateInstring(period) : fixedPeriods?.find(x => x.value == period)?.label} | Reportes ${local != 'todos' ? `- ${locais?.find(x => x.value == local)?.label}` : ""}`} />}

                            {local == 'todos' && <Grid container mt={5} spacing={3}>
                                <Grid display="flex" justifyContent="center" item xs={10} md={6} lg={4}>
                                    <MDBox mb={1.5}>
                                        <PichartReport loading={loading2} data={chartData?.local?.pie} label={`${period.toString()?.includes('startDate') ? getDateInstring(period) : fixedPeriods?.find(x => x.value == period)?.label} | Reportes por site`} />
                                    </MDBox>
                                </Grid>
                                <Grid item xs={12} md={6} lg={8}>
                                    <MDBox mb={1.5}>
                                        <BarChart loading={loading2} data={chartData?.local.bar} label={`${period.toString()?.includes('startDate') ? getDateInstring(period) : fixedPeriods?.find(x => x.value == period)?.label} | Situação por site`} />
                                    </MDBox>
                                </Grid>
                            </Grid>}

                            {selected === 'nearmisses' && <Grid container mt={5} spacing={3}>
                                <Grid display="flex" justifyContent="center" item xs={10} md={6} lg={4}>
                                    <MDBox mb={1.5}>
                                        <PichartReport loading={loading2} data={chartData?.stop_card?.pie} label={`${period.toString()?.includes('startDate') ? getDateInstring(period) : fixedPeriods?.find(x => x.value == period)?.label} | Stop Cards ${local != 'todos' ? `- ${locais?.find(x => x.value == local)?.label}` : ""}`} />
                                    </MDBox>
                                </Grid>
                                <Grid item xs={12} md={6} lg={8}>
                                    <MDBox mb={1.5}>
                                        <BarChart loading={loading2} data={chartData?.stop_card.bar} label={`${period.toString()?.includes('startDate') ? getDateInstring(period) : fixedPeriods?.find(x => x.value == period)?.label} | Situação por stop card ${local != 'todos' ? `- ${locais?.find(x => x.value == local)?.label}` : ""}`} />
                                    </MDBox>
                                </Grid>
                            </Grid>}

                            <Grid container mt={5} spacing={3}>
                                <Grid display="flex" justifyContent="center" item xs={10} md={6} lg={4}>
                                    <MDBox mb={1.5}>
                                        <PichartReport loading={loading2} data={chartData?.classe?.pie} label={`${period.toString()?.includes('startDate') ? getDateInstring(period) : fixedPeriods?.find(x => x.value == period)?.label} | Reportes por classe ${local != 'todos' ? `- ${locais?.find(x => x.value == local)?.label}` : ""}`} />
                                    </MDBox>
                                </Grid>
                                <Grid item xs={12} md={6} lg={8}>
                                    <MDBox mb={1.5}>
                                        <BarChart loading={loading2} data={chartData?.classe.bar} label={`${period.toString()?.includes('startDate') ? getDateInstring(period) : fixedPeriods?.find(x => x.value == period)?.label} | Situação por classe ${local != 'todos' ? `- ${locais?.find(x => x.value == local)?.label}` : ""}`} />
                                    </MDBox>
                                </Grid>
                            </Grid>

                            <Grid container mt={5} mb={10} spacing={3}>
                                <Grid display="flex" justifyContent="center" item xs={12} md={6} lg={4}>
                                    <MDBox mb={1.5}>
                                        <PichartReport loading={loading3} data={goldenRulesChart.possiveisDanos.aggregate} label={`${period.toString()?.includes('startDate') ? getDateInstring(period) : fixedPeriods?.find(x => x.value == period)?.label} | Reportes pelos possíveis danos ${local != 'todos' ? `- ${locais?.find(x => x.value == local)?.label}` : ""}`} />
                                    </MDBox>
                                </Grid>
                                <Grid item xs={12} md={6} lg={8}>
                                    <MDBox mb={1.5}>
                                        <BarChart loading={loading3} data={goldenRulesChart.possiveisDanos.byStatus} label={`${period.toString()?.includes('startDate') ? getDateInstring(period) : fixedPeriods?.find(x => x.value == period)?.label} | Situação pelos possíveis danos ${local != 'todos' ? `- ${locais?.find(x => x.value == local)?.label}` : ""}`} />
                                    </MDBox>
                                </Grid>
                            </Grid>

                            {(() => {
                                const label = `${period.toString()?.includes('startDate') ? getDateInstring(period) : fixedPeriods?.find(x => x.value == period)?.label} | Situação por Colaborador ${local != 'todos' ? `- ${locais?.find(x => x.value == local)?.label}` : ""}`
                                return (
                                    <MDBox mt={5}>
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                                            <h6 style={{ margin: 0 }}>{label}</h6>
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                <Switch checked={showTable} onChange={(checked) => setShowTable(checked)} checkedChildren="Tabela" unCheckedChildren="Gráfico" />
                                            </div>
                                        </div>
                                        {showTable ? (
                                            <ReportTable data={chartData?.reportado_por?.bar} />
                                        ) : (
                                            <BarChart loading={loading2} data={chartData?.reportado_por?.bar} label={""} />
                                        )}
                                    </MDBox>
                                )
                            })()}

                            {/* <Grid mt={15} mb={7} spacing={3}>
                                <GoldenRulesChart loading={loading3} data={goldenRulesChart?.regrasDeOuro?.aggregate} label={`${period.toString()?.includes('startDate') ? getDateInstring(period) : fixedPeriods?.find(x=>x.value==period)?.label} | Associação aos golden rules ${local != 'todos' ? `- ${locais?.find(x => x.value == local)?.label}` : ""}`} />
                                <Grid container mt={5} />
                                <GoldenRulesChart loading={loading3} data={goldenRulesChart?.regrasDeOuro?.byStatus} label={`${period.toString()?.includes('startDate') ? getDateInstring(period) : fixedPeriods?.find(x=>x.value==period)?.label} | Estado dos near miss associados os golden rules ${local != 'todos' ? `- ${locais?.find(x => x.value == local)?.label}` : ""}`} />
                            </Grid> */}

                            <Grid container mt={5} spacing={3} />
                        </MDBox>
                    </Card>
                </Grid>
            </Grid>
        </Layout>
    );
}

export default Relatorios;
